import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ShowTradeByIdComponent} from '../issuer-mapping/show-trade-by-id/show-trade-by-id.component';
import {SelectionModel} from '@angular/cdk/collections';
import {SenatorNoGvKeyConfirmation} from '../../../../api/models/senator-no-gv-key-confirmation';
import {SenatorCompany} from '../../../../api/models/senator-company';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SenatorQualityGateService} from '../../../../api/services/senator-quality-gate.service';
import {SenatorService} from '../../../../api/services/senator.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {SenatorQualityGateFilterModel} from '../../../../api/models/senator-quality-gate-filter-model';
import {SenatorTrades} from '../../../../api/models/senator-trades';
import {
  SenatorMarketTradedSecurityConfirmationService
} from '../../../../api/services/senator-market-traded-security-confirmation.service';
import {SenatorMarketTradedSecurityConfirmation} from '../../../../api/models/senator-market-traded-security-confirmation';
import {EditCompanyComponent} from '../issuer-mapping/all-companies/edit-company/edit-company.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-is-market-traded',
  templateUrl: './is-market-traded.component.html',
  styleUrls: ['./is-market-traded.component.css']
})
export class IsMarketTradedComponent implements OnInit, AfterViewInit {

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;
  selection = new SelectionModel<SenatorNoGvKeyConfirmation>(true, []);

  twoIQAssetsList: SenatorCompany[] = [];
  // mat table vars
  nonGvkeyConfirmationColumns: string[] = ['companyName', 'gvkey', 'tradeCount', 'assetClass', 'financialInstrument', 'compustatTicker',
    'BBGTicker', 'isMarketTraded', 'actions'];
  displayedColumns: string[] = this.nonGvkeyConfirmationColumns;
  issuerTableDataSource: MatTableDataSource<SenatorMarketTradedSecurityConfirmation>;

  processedTypes = ['ALL', 'PROCESSED', 'UNPROCESSED'];
  selectedProcessedType;
  selectedSearchProcessedType;

  pageSize: number;
  pageNumber: number;
  searchPageNumber: number;
  lastPageNumber: number;
  lastSearchPageNumber: number;
  isSearchingIssuerName: boolean;
  searchString: string;
  lastSearchString: string;
  isLastActionSearch: boolean;

  pageSizeOptions: number[] = [10, 20, 50, 100, 200];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  multipleSelectNoGvkeyForm: FormGroup;

  loadingData = false;
  assetNamesLoading: boolean;

  hideFilters = false;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder,
              private changeDetectorRefs: ChangeDetectorRef,
              private router: Router, private dialog: MatDialog,
              private _senatorMarketTradedSecurityConfirmationService: SenatorMarketTradedSecurityConfirmationService) {
  }


  ngOnInit() {
    this.initVars();
    this.getRecords();
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource != null) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.searchPageNumber = 1;
    this.lastPageNumber = 1;
    this.lastSearchPageNumber = 1;
    this.selectedProcessedType = 'ALL';
    this.selectedSearchProcessedType = 'ALL';
    this.assetNamesLoading = false;
    this.isSearchingIssuerName = false;
    this.searchString = '';
    this.lastSearchString = '';
    this.isLastActionSearch = false;
    this.createMultipleSelectNoGvkeyForm();
  }

  createMultipleSelectNoGvkeyForm() {
    this.multipleSelectNoGvkeyForm = this._fb.group({
      'multiselectNew2iqAssetName': [null, Validators.required],
      'multiselectGvkey': [null, Validators.required],
      'multiselectPermid': [],
    });
  }

  getRecords(value?: string) {
    if (this.isSearchingIssuerName)
      value = this.searchString;
    this.loadingData = true;

    const params: SenatorQualityGateFilterModel = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      processedType: this.selectedProcessedType == 'ALL' ? 'ALL' :
        this.selectedProcessedType == 'PROCESSED' ? 'PROCESSED' : 'UNPROCESSED',
      qualityGateType: null,
      searchByCompanyName: value,

    };
    this._senatorMarketTradedSecurityConfirmationService.getSenatorMarketTradedSecurityConfirmation(params).subscribe(
      (res: SenatorMarketTradedSecurityConfirmation[]) => {
        this.issuerTableDataSource = new MatTableDataSource<SenatorMarketTradedSecurityConfirmation>(res);
        //  console.log('issuerTableDataSource res', res);

      },
      error => {
        this.loadingData = false;
      },
      () => {
        this.loadingData = false;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;
        this.displayedColumns = this.nonGvkeyConfirmationColumns;
        this.hideFilters = false;
      }
    );
  }

  onProcessClick(row: SenatorNoGvKeyConfirmation, action: string) {
    row.isProcessed = true;
    switch (action) {
      case  'Process':
        row.isProcessed = true;
        break;
      case  'UnProcess':
        row.isProcessed = false;
        break;
    }
    const params: SenatorMarketTradedSecurityConfirmation = row;
    this._senatorMarketTradedSecurityConfirmationService.updateSenatorMarketTradedSecurityConfirmation(params).subscribe((res: SenatorNoGvKeyConfirmation) => {
      },
      err => {
        this.loadingData = false;
        this.openSnackBar(err.error.message, 'Close');
      },
      () => {
        this.loadingData = false;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;

        this.displayedColumns = this.nonGvkeyConfirmationColumns;
        this.hideFilters = false;
        this.openSnackBar(`Issuer has been marked as ${action}`, 'Close');
      }
    );
  }


  searchAssetNames(companyName: string, trade: SenatorTrades) {
    // this.activeRow = trade;
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  tradeClosedEvent() {
    this.getRecords();
  }

  selectionChanged(value: boolean) {
    if (value == false) {
      this.getRecords();
    }
  }

  applySearch(value: string) {
    this.selection.clear();
    if (value.length === 0) {
      //if search removed
      this.isSearchingIssuerName = false;

      if (this.isLastActionSearch) {
        this.lastSearchPageNumber = this.pageNumber;
        this.pageNumber = this.lastPageNumber;
      }
      this.getRecords();
      this.isLastActionSearch = false;
    } else {
      //if searched something
      this.isSearchingIssuerName = true;
      if (!this.isLastActionSearch) {
        this.lastPageNumber = this.pageNumber;
      }
      if (value != this.searchString) {
        //if in case searched something that is new than previous search
        this.lastSearchString = this.searchString;
        this.lastSearchPageNumber = 1;
        this.searchString = value;

      } else {
        //if in case searched something that is the same as pervious one
        this.pageNumber = this.lastSearchPageNumber;
      }
      this.pageNumber = this.lastSearchPageNumber;

      this.getRecords(value);
      this.isLastActionSearch = true;
    }
  }

  onPaginateChange(event: PageEvent) {

    if (event.pageSize != this.pageSize) {
      this.selection.clear();
    }

    if (!this.isSearchingIssuerName) {
      //if search removed and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getRecords();
      // console.log('onPaginateChange: event', event);

    } else {
      //if searched something and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastSearchPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getRecords(this.searchString);
      // console.log('search onPaginateChange: event', event);
    }
  }


  private editCompany(row: SenatorCompany) {
    const dialogRef = this.dialog.open(EditCompanyComponent, {
      disableClose: true,
      width: '1100px',
      data: row
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('res', result);

    });
  }


}
